import { GetAllAssessmentRequirementsParams } from 'api/company/position/requirement/getAllAssessmentRequirements'
import type { GetAllRequirementsRequest } from 'api/company/position/requirement/getAllPositionRequirements'

export const companyKey = ['company']

export const companyDetailKey = (companyId: number) => [
  ...companyKey,
  companyId,
]

export const companySwitchKey = [...companyKey, 'switch']
export const positionTemplatesKey = [...companyKey, 'positionTemplates']
export const positionTemplateKey = (positionTemplateId?: number) => [
  ...companyKey,
  'positionTemplate',
  positionTemplateId?.toString(),
]
export const positionPositionTemplateMutationKey = (positionId: number) => [
  ...companyKey,
  'positionPositionTemplateMutation',
  positionId.toString(),
]
export const positionKey = (positionId: number | null) => [
  ...companyKey,
  'position',
  positionId?.toString(),
]
export const companyLocationsKey = (companyId: number) => [
  ...companyKey,
  companyId,
  'locations',
]

export const cushionChargePoliciesKey = (companyId: number) =>
  [...companyKey, companyId, 'cushionChargePolicies'] as const

export const companyFilesKey = (
  companyId?: number,
  params?: { page?: number; pageSize?: number }
) =>
  params
    ? ([...companyKey, companyId, 'files', params] as const)
    : ([...companyKey, companyId, 'files'] as const)

export const companyFileFieldsKey = (companyId?: number, fileId?: number) =>
  [...companyKey, companyId, 'files', fileId, 'fields'] as const

export const companiesForFiltersKey = (
  grouping?: 'upcoming' | 'past' | 'ongoing'
) => [...companyKey, 'companiesForFilters', grouping ?? 'default'] as const

export const upcomingShiftsForPositionKey = (
  positionId: number,
  companyId: number
) =>
  [...companyKey, 'upcomingShiftsForPosition', positionId, companyId] as const

export const requirementDataForPositionKey = (positionId: number | null) =>
  [...companyKey, 'requirementDataForPosition', positionId] as const

export const allRequirementsForAdminKey = (
  params: GetAllRequirementsRequest | null
) => [...companyKey, 'allRequirementsForAdmin', params] as const

export const positionAssessmentLevelsKey = (
  params: GetAllAssessmentRequirementsParams
) => [...companyKey, 'positionAssessmentLevels', params] as const
